import { render, staticRenderFns } from "./PetugasTcAktif.vue?vue&type=template&id=0b93effd&"
import script from "./PetugasTcAktif.vue?vue&type=script&lang=js&"
export * from "./PetugasTcAktif.vue?vue&type=script&lang=js&"
import style0 from "./PetugasTcAktif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports